import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";

const fetchApplicationForm = (studentId: number, courseId: number): AxiosPromise<StudentCourseForm> => {
  return api.get<StudentCourseForm>(endpoints.STUDENT_FORMS.GET_APPLICATION_FORM(studentId, courseId));
};

const updateBuyerFields = (
  studentId: number,
  courseId: number,
  body: UpdateBuyerFieldsRequest,
): AxiosPromise<void> => {
  return api.put(endpoints.STUDENT_FORMS.UPDATE_BUYER_FIELDS(studentId, courseId), body);
};

export const studentFromsApi = {
  fetchApplicationForm,
  updateBuyerFields,
};

export interface StudentCourseForm {
  registrationId: number;
  createdDate: Date;
  isInvoice: boolean;
  buyer?: string;
  buyerNIP?: string;
  buyerAddress?: string;
  groups: {
    name: string;
    description?: string;
    fields: {
      id: number;
      name: string;
      type: number;
      value: string;
    }[];
  }[];
}

export interface UpdateBuyerFieldsRequest {
  isInvoice: boolean;
  buyer?: string;
  buyerNip?: string;
  buyerAddress?: string;
}
